export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-960-f26c1799658bf895fa3816b737f5544d.png";